import { StyleSheet } from 'react-native';

import { androidScreenMarginBottom } from 'utils/responsiveness.ts';

const styles = StyleSheet.create({
    dialog: {
        marginBottom: androidScreenMarginBottom,
    },
});

export default styles;
